import React from "react";
import Switch from "react-switch"

import styles from "./CustomSwitchField.module.css"
import classnames from "classnames";

interface FieldProps {
    textOnTrue: string
    textOnFalse: string
    value: boolean | undefined;
    toggleValue: (v: boolean) => void
    disabled?: boolean
}

export const CustomSwitchField: React.FC<FieldProps> = ({
                                                            textOnTrue,
                                                            textOnFalse,
                                                            value,
                                                            toggleValue,
                                                            disabled = false
                                                        }) => {
    return <div className={styles.switchWrapper}>
        <span className={classnames(styles.onOff, disabled && styles.disabledText)}>{value ? textOnTrue : textOnFalse}</span>
        <Switch
            onChange={toggleValue}
            checked={!!value}
            offColor="#8C96A1"
            onColor="#21524D"
            boxShadow="none"
            activeBoxShadow="none"
            disabled={disabled}
            className={classnames(disabled ? styles.disabledSwitch : '')}
        />
    </div>
}
